import { createSlice } from "@reduxjs/toolkit";

export const bidderAuthSlice = createSlice({
  name: "bidderAuth",
  initialState: {
    user: null,
    accessToken: null,
    mobile: null,
    email: null,
    onboarding: null,
    portalAccessType: null,
  },

  reducers: {
    setBidderUser: (state, action) => {
      state.user = action.payload;
    },

    setBidderTokens: (state, action) => {
      state.accessToken = action.payload.access_token;
    },
    setBidderEmail: (state, action) => {
      state.email = action.payload;
    },
    setBidderMobile: (state, action) => {
      state.mobile = action.payload;
    },

    setBidderOnboarding: (state, action) => {
      state.onboarding = action.payload;
    },
    setBidderPortalAccessType: (state, action) => {
      state.portalAccessType = action.payload;
    },

    clearBidderMobile: (state) => {
      state.mobile = null;
    },

    clearBidderAuth: (state) => {
      state.user = null;
      state.accessToken = null;
      state.email = null;
      state.mobile = null;
      state.onboarding = null;
      state.portalAccessType = null;
    },
  },
});

export const {
  setBidderUser,
  setBidderTokens,
  setBidderEmail,
  setBidderMobile,
  clearBidderMobile,
  clearBidderAuth,
  setBidderOnboarding,
  setBidderPortalAccessType,
} = bidderAuthSlice.actions;

export default bidderAuthSlice.reducer;
